


























































helpers = require('../../../helpers.coffee')

view_model =
  mixins: [
    require('../../../mixins/users_options.coffee')
  ]

  components:
    draggable: require('vuedraggable')

  props: {
    stages_matching: Array,
    integration_name: String,
    integration_stages: {
      default: [],
      type: Array
    },
    pipelines: {
      default: () -> return [],
      type: Array
    },
    pipeline_id: {
      type: [String, Number, Object],
      default: null
    },
    integration_no_stages_api: {
      type: Boolean,
      default: false
    },
    show_ignore_stages: {
      type: Boolean,
      default: false
    }
  }

  data: ->
    current_user: Session.current_user
    reev_stages: []
    matching: []
    update_all_users: false
    user_stage_setting: null
    stage_options: [
      { value: { stage_query: null }, text: this.$t('integrations.label.stages_matching.stage'), ignore: true }
      { value: { stage_query: 'smart_lead' }, text: this.$t('integrations.label.stages_matching.smartLead') }
      { value: { stage_query: 'prospect' }, text: this.$t('integrations.label.stages_matching.prospect') }
      { value: { stage_query: 'lead' }, text: this.$t('integrations.label.stages_matching.lead') }
      { value: { stage_query: 'mql' }, text: this.$t('integrations.label.stages_matching.mql') }
      { value: { stage_query: 'sql' }, text: this.$t('integrations.label.stages_matching.sql') }
      { value: { stage_query: 'opportunity' }, text: this.$t('integrations.label.stages_matching.opportunity') }
      { value: { stage_query: 'client' }, text: this.$t('integrations.label.stages_matching.customer') }
    ]
    selected_pipeline: null

  methods:
    defaultFields: ->
      [
        { key: 'smart_lead', name: this.$t('integrations.label.stages_matching.smartLead') }
        { key: 'prospect', name: this.$t('integrations.label.stages_matching.prospect') }
        { key: 'lead', name: this.$t('integrations.label.stages_matching.lead') }
        { key: 'mql', name: this.$t('integrations.label.stages_matching.mql') }
        { key: 'sql', name: this.$t('integrations.label.stages_matching.sql') }
        { key: 'opportunity', name: this.$t('integrations.label.stages_matching.opportunity') }
        { key: 'client', name: this.$t('integrations.label.stages_matching.customer') }
        { key: 'lost', name: this.$t('integrations.label.stages_matching.lost') }
      ]

    validateApiFields: ->
      default_integration_id = ''
      if @integration_stages.length > 0 
        if @integration_name == 'pipedrive' || @integration_name == 'cv crm'
          default_integration_id = this.$t('integrations.label.ignore')
        else
          default_integration_id =  @integration_stages[0].id
      @matching = @stage_options.filter((field) -> return !field.ignore ).map (field) -> { option: { stage_query: null }, reev: field.value.stage_query, reev_name: field.text, integration: default_integration_id, integration_name: '' }
      if @integration_no_stages_api
        if @stages_matching?.length > 0
          @matching = @stages_matching.map (field) -> { option: { stage_query: field.reev }, integration: field.integration, integration_name: field.integration_name, reev_name: field.reev_name }

      else
        if @stages_matching?.length > 0
          self = @
          @matching = @stage_options.filter((field) -> return !field.ignore ).map (field) ->
            integration_value = self.stages_matching.find (stage) -> stage.reev == field.value.stage_query
            { option: { stage_query: null }, reev: field.value.stage_query, reev_name: field.text, integration: {stage_query: integration_value?.integration.toString() || default_integration_id }, integration_name: '' }

        @updateProps()

    toggleUpdateAllUsers: ->
      @update_all_users = !@update_all_users
      @$emit('users-update', { @update_all_users, user_id: @user_stage_setting?.user_id_eq })

    updateProps: ->
      array = @matching.map (field) ->
        integration = field.integration
        if typeof field.integration == 'object'
          integration = field.integration.stage_query
        { integration: integration, integration_name: field.integration_name, reev_name: field.reev_name, reev: field.option?.stage_query || field.reev }
      @$emit('matching-updated', array)

    updateStages: ->
      @$emit('update-stages', { pipeline: @selected_pipeline })

  computed:
    draggable_options: ->
      {
        animation: 0,
        group: "description",
        disabled: false
      }

    integration_stages_options: ->
      stages = @integration_stages.map (stage) -> { value: { stage_query: stage.id.toString() }, text: stage.name }
      if @show_ignore_stages
        stages.unshift({ value: { stage_query: this.$t('integrations.label.ignore') }, text: this.$t('general.actions.ignore') })
      stages

  watch:
    integration_stages: ->
      @validateApiFields()

    user_stage_setting: ->
      @$emit('users-update', { @update_all_users, user_id: @user_stage_setting?.user_id_eq })

    integration_no_stages_api: ->
      if @integration_no_stages_api
        @validateApiFields()

    pipeline_id: ->
      @selected_pipeline = @pipeline_id

    stages_matching: ->
      @validateApiFields()

  mounted: ->
    Tooltip.initialize()
    @reev_stages = @defaultFields()
    @validateApiFields()
    @selected_pipeline = @pipeline_id
    @user_stage_setting = { user_id_eq: Session.current_user.id.toString() } if Session.current_user.isManager()
    if ['hubspot', 'pipedrive', 'rd station crm', 'cv crm'].indexOf(@integration_name.toLowerCase()) > -1
      @stage_options.push({ value: { stage_query: 'lost' }, text: this.$t('integrations.label.stages_matching.lost') })

exports.default = helpers.vue_include(view_model, helpers.form)




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/configuration/integrations/stages_matching.vue